var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiltedLightLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 171,
    viewBox: "0 0 286 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.415 208.383L114.592 190.554C144.116 181.827 161.639 156.168 149.704 114.546L145.812 100.971C126.716 36.3813 65.4965 10.7181 0.984833 28.9641L28.0627 123.396C31.3693 134.927 38.3768 160.549 76.0755 149.739L88.0815 146.297L88.9462 149.312L60.4149 157.493C48.8833 160.8 42.2185 172.824 45.5251 184.355L52.415 208.383Z",
    fill: "rgba(255, 255, 255, 0.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.037 141.68L222.86 159.509C193.198 167.753 164.74 155.279 152.805 113.656L148.912 100.082C130.871 35.1899 169.197 -19.0177 233.575 -37.7301L260.652 56.7016C263.959 68.2331 271.594 93.675 233.895 104.485L221.889 107.928L222.754 110.943L251.285 102.762C262.817 99.4553 274.84 106.12 278.147 117.652L285.037 141.68Z",
    fill: "rgba(255, 255, 255, 0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltedLightLogomark);
export default __webpack_public_path__ + "static/media/tilted-light-logomark.6a1df969f5a5954586991b5a4753249f.svg";
export { ForwardRef as ReactComponent };